class CompareProductsService {
  constructor ($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.$httpParamSerializerJQLike= $httpParamSerializerJQLike;
  }
  
  getProductToCompare(idsProductsToCompare, userId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.compareProducts + idsProductsToCompare + '&userId=' + userId,
        cache : false
      }).then((response) => {
        resolve(response.data);
      }, reason => {
        reject(reason);
      });
    });
    
    
  }
}

CompareProductsService.$inject = ['$q','$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

export default CompareProductsService;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/compare-products/compare-products.service.js
 **/